import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from "redux-form";
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import IconAdd from 'material-ui/svg-icons/content/add-circle';
import Dialog from 'material-ui/Dialog';
import EditSelectChipInput from './EditSelectChipInput';
import EditSelectColorChipInput from './EditSelectColorChipInput';


class VariantsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      defaultOptions: props.dataOptions
    };
  }
  handleOpen = () => {
    this.setState({open: true});
  };
  handleCancel = () => {
    this.props.onCancel(this.state.defaultOptions);
    this.setState({open: false});
  };
  handleSubmit = () => {
    this.props.onSave();
    this.setState({open: false});
  };
  
  renderOptionsList = ({ fields, meta: { error, submitFailed } }) => {
    return (
      <div>
        {fields.map(this.renderOptionsFields)}
      </div>
    );
  };
  renderColorField = (items, values) => {
    return (
      <Field
        label="Color"
        name={`${items}.values`}
        component={EditSelectColorChipInput}
        elStyle={{ marginBottom: 20, marginTop: 0 }}
      />
    )
  };
  renderOptionsFields = (items, index, fields) => (
    <div key={index}>
        {this.props.record.variant.options[index].name === "color" ? (
          this.renderColorField(items, this.props.record.variant.options[index].values)
        ) : (
          <Field
            label={this.props.record.variant.options[index].name}
            name={`${items}.values`}
            component={EditSelectChipInput}
            dataOptions={this.props.variant.options[index].values}
            elStyle={{ marginBottom: 20, marginTop: 0 }}
          />
        )}
     </div> 
  );

  render() {
    const {translate} = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleCancel}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmit}
      />,
    ];
    return (
      <div>
        <RaisedButton
          label={translate('resources.products.actions.addVariant')}
          labelPosition="after"
          onClick={this.handleOpen}
          primary={true}
          icon={<IconAdd />}
        />
        <Dialog
          title={translate('resources.products.actions.addVariant')}
          actions={actions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleCancel}
        >
          <div>
            <FieldArray
              name="variant.options"
              component={this.renderOptionsList}
            />
          </div>  
        </Dialog>
      </div>  
    );
  }
}  

VariantsDialog.propTypes = {
  onCancel: PropTypes.func,
  onSave: PropTypes.func, 
  dataOptions: PropTypes.object
}

export default VariantsDialog;


// WEBPACK FOOTER //
// ./src/products/edit/VariantsDialog.js